import apiRequest from './api';

export function getUsers(token, params = {}) {
  const searchParams = new URLSearchParams();

  if (params.customer_id) {
    searchParams.set('customer_id', params.customer_id);
  }

  if (params.branch_id) {
    searchParams.set('branch_id', params.branch_id);
  }

  if (params.user_type !== undefined) {
    searchParams.set('user_type', params.user_type);
  }

  const suffix = searchParams.toString() ? `?${searchParams.toString()}` : '';

  return apiRequest(`/users${suffix}`, {
    method: 'GET',
    token,
  });
}

export function createUser(token, payload) {
  return apiRequest('/users', {
    method: 'POST',
    token,
    body: JSON.stringify(payload),
  });
}

export function updateUser(token, userId, payload) {
  return apiRequest(`/users/${userId}`, {
    method: 'PATCH',
    token,
    body: JSON.stringify(payload),
  });
}

export function resetUserPassword(token, userId) {
  return apiRequest(`/users/${userId}/reset-password`, {
    method: 'POST',
    token,
  });
}
